import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import NumberFormatDecorator from './NumberFormat'
import { useAlert } from '../ui/Alert'
import moment from 'moment'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'
import config from './../constants'
import { NotAutorized } from './NotAutorized'

export default function DataTable({
  resource = {},
  column = [],
  update = true,
  deleteItem = true,
  view = false,
  action,
  show_header = true,
  show_btn = true,
  title = '',
  link = '',
}) {
  const [data, setData] = useState(),
    [loading, setLoading] = useState(true),
    { push } = useAlert(),
    [limit, setLimit] = useState(10),
    [page, setPage] = useState(1),
    [fail, setFail] = useState(false)
  const search = useLocation().search

  const from = data?.offset + 1
  const to = data?.offset + data?.limit
  const total = data?.totalDocs

  const handleClickOpen = async (id) => {
    const { value } = await Swal.fire({
      title: 'Are you sure?',
      text: "you want to delete this entity, you can't go back",
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: 'Yes, delete it!',
      closeOnConfirm: false,
    })
    if (value) onDelete(id)
  }

  async function onGet(limit_data, page_data) {
    let search_str = ''
    const name = new URLSearchParams(search).get('s')

    if (name) {
      search_str = `&s=${name}`
    }
    setLoading(true)
    let res = await resource
      .read(limit_data, page_data, search_str)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      setData(res.data)
    } else if (res.status === 403) {
      setFail(true)
    }

    setLoading(false)
  }

  const there_is_action = Object.prototype.toString.call(action).indexOf('Function') > 0

  async function onDelete(id) {
    let res = await resource
      .delete(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      push({
        success: true,
      })
      onGet()
    } else if (res.status === 403) {
      push({
        error: true,
        message: config.app.error,
      })
    } else if (res.status === 401) {
      push({
        error: true,
        message: res.data,
      })
    }
  }

  const onLimitChange = async (e) => {
    setLimit(e.target.value)
    setPage(1)
    onGet(e.target.value, 1)
  }

  const onPageChange = async (e, item) => {
    e.preventDefault()
    setPage(item)
    onGet(limit, item)
  }

  useEffect(() => {
    onGet(limit, page)
  }, [])

  return loading ? (
    <div className="d-flex align-items-center justify-content-center">
      <div className="spinner-grow" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : fail ? (
    <NotAutorized />
  ) : (
    <div className="card table-card">
      {show_header && (
        <div className="card-header">
          {Boolean(title) && <h5>{title}</h5>}
          {show_btn && Boolean(link) && (
            <div className="card-header-right" style={{ right: '20PX' }}>
              <a href={`${link}/create`} className="btn waves-effect waves-light btn-primary">
                <i className="feather icon-plus"></i>
                New entity
              </a>
            </div>
          )}
        </div>
      )}

      <div className="card-block">
        <div className="dt-responsive table-responsive">
          <table id="simpletable" className="table mt-3 nowrap">
            <thead>
              <tr className="table-inverse">
                <th>Num</th>
                {column &&
                  column.map((i, k) => {
                    return <th key={k}>{i.label}</th>
                  })}
                {(update || view || deleteItem || there_is_action) && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {data?.docs?.map((el, key) => {
                return (
                  <tr key={key}>
                    <td>{(page - 1) * limit + (key + 1)}</td>
                    {column.map((i, k) => {
                      if (i.renderStyle) {
                        return <td key={k}>{i.renderStyle(el)}</td>
                      }

                      if (i.render) {
                        const render = i.render.map((a) => {
                          if (el.hasOwnProperty(i.field) && el[i.field]) {
                            return el[i.field][a]
                          }
                        })
                        return <td key={k}>{render}</td>
                      }

                      if (el.hasOwnProperty(i.field)) {
                        if (i.isDate) {
                          return <td key={k}>{moment(el[i.field]).utc().format('DD/MM/YYYY')}</td>
                        }
                        if (i.isTime) {
                          return <td key={k}>{moment(el[i.field]).utc().format('hh:mm:ss')}</td>
                        }
                        if (i.isMoney) {
                          return (
                            <td key={k}>
                              <NumberFormatDecorator value={el[i.field]} />
                            </td>
                          )
                        } else {
                          return <td key={k}>{el[i.field]}</td>
                        }
                      } else {
                        return <td key={k} />
                      }
                    })}

                    {(update || view || deleteItem || there_is_action) && (
                      <td>
                        <div className="dropdown">
                          <i
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="feather icon-more-vertical"
                            style={{
                              cursor: 'pointer',
                            }}
                          ></i>

                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            {view && (
                              <li>
                                <a className="dropdown-item" href={`${link}/view/${el.id}`}>
                                  <i className="feather icon-eye"></i> Visualiser
                                </a>
                              </li>
                            )}
                            {update && (
                              <li>
                                <a className="dropdown-item" href={`${link}/edit/${el.id}`}>
                                  <i className="feather icon-edit"></i> Edit
                                </a>
                              </li>
                            )}

                            {deleteItem && (
                              <li>
                                <span
                                  className="dropdown-item"
                                  style={{
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => handleClickOpen(el.id)}
                                >
                                  <i className="feather icon-trash-2"></i> Delete
                                </span>
                              </li>
                            )}

                            {there_is_action && action(el, onGet)}
                          </ul>
                        </div>
                      </td>
                    )}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <div className="row mt-2 p-l-20 p-r-20">
          <div className="col-xs-12 col-sm-12 col-md-2">
            <select
              className="form-select form-control form-control-default fill form-select-sm"
              aria-label="Default select example"
              onChange={onLimitChange}
              value={limit}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={5000}>5000</option>
            </select>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-4">
            <div className="dataTables_info" id="lang-dt_info" role="status" aria-live="polite">
              Showing {isNaN(from) ? 0 : from} to {isNaN(to) ? 0 : to} of {total ?? 0} entries
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6">
            <div className="dataTables_paginate paging_simple_numbers" id="lang-dt_paginate">
              <ul className="pagination">
                <li
                  className={`paginate_button page-item previous
										${!data?.hasPrevPage ? 'disabled' : ''}`}
                  id="lang-dt_previous"
                >
                  <a
                    onClick={(e) => onPageChange(e, data?.prevPage)}
                    href="#!"
                    aria-controls="lang-dt"
                    data-dt-idx="0"
                    tabIndex="0"
                    className="page-link"
                  >
                    Previous
                  </a>
                </li>
                <li className="paginate_button page-item active">
                  <a
                    href="#!"
                    aria-controls="lang-dt"
                    data-dt-idx="1"
                    tabIndex="0"
                    className="page-link"
                  >
                    {page}
                  </a>
                </li>
                <li
                  className={`paginate_button page-item next ${
                    !data?.hasNextPage ? 'disabled' : ''
                  }`}
                  id="lang-dt_next"
                >
                  <a
                    onClick={(e) => onPageChange(e, data?.nextPage)}
                    href="#!"
                    aria-controls="lang-dt"
                    data-dt-idx="3"
                    tabIndex="0"
                    className="page-link"
                  >
                    Next
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

DataTable.propTypes = {
  resource: PropTypes.object.isRequired,
  column: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
    })
  ).isRequired,
  update: PropTypes.bool,
  deleteItem: PropTypes.bool,
  view: PropTypes.bool,
  action: PropTypes.func,
  show_header: PropTypes.bool,
  show_btn: PropTypes.bool,
  title: PropTypes.string,
  link: PropTypes.string,
}

DataTable.defaultProps = {
  resource: {},
  column: [],
  update: true,
  deleteItem: true,
  view: false,
  show_header: true,
  show_btn: true,
  title: '',
  btn: '',
}
